import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-container" }

import { ElIcon } from 'element-plus'
import { Loading } from '@element-plus/icons-vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'loading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElIcon), {
      size: 36,
      class: "loading"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading))
      ]),
      _: 1
    }),
    _cache[0] || (_cache[0] = _createElementVNode("span", null, "正在加载...", -1))
  ]))
}
}

})